import * as React from "react";
import type { SVGProps } from "react";
const SvgBankIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      stroke="#858585"
      strokeWidth={0.857}
      d="M4.303 10.706v-.428H2.68a.13.13 0 0 1-.131-.132V7.807c0-.054.034-.104.085-.123l11.27-4.237a.13.13 0 0 1 .092 0l11.27 4.237c.052.02.086.069.086.123v2.34a.13.13 0 0 1-.132.13h-1.829v12.53h-.242v-12.53H19.89v12.53h-.242v-12.53H8.046v12.53h-.243v-12.53H4.546v12.53h-.243zm9.798-6.96-.151-.057-.15.057L3.07 7.78l-.279.104v2.151H25.11V7.884l-.278-.104z"
    />
    <path
      fill="#858585"
      d="M14.195 16.372c-.537 0-.973-.392-.973-.875 0-.482.436-.875.973-.875.535 0 .972.393.972.875 0 .194.174.35.389.35.214 0 .389-.156.389-.35 0-.748-.583-1.376-1.362-1.535v-.39c0-.193-.174-.35-.389-.35-.214 0-.388.157-.388.35v.39c-.779.16-1.361.787-1.361 1.535 0 .869.784 1.575 1.75 1.575.535 0 .972.393.972.875 0 .483-.437.875-.973.875s-.972-.392-.972-.875c0-.193-.174-.35-.389-.35-.214 0-.389.157-.389.35 0 .748.583 1.376 1.362 1.536v.39c0 .192.174.35.389.35.214 0 .388-.157.388-.35v-.39c.779-.16 1.361-.788 1.361-1.536 0-.868-.785-1.575-1.75-1.575"
    />
  </svg>
);
export default SvgBankIcon;
